export enum WoundColorEnum {
  Clear = 1,
  Tan = 2,
  Serosanguineous = 3,
  Strong = 4,
  Other = 99
}

export const WoundColorOptions = [
{ id: 1, label: 'None' },
{ id: 2, label: 'Slight' },
{ id: 3, label: 'Serosanguineous' },
{ id: 4, label: 'Strong' },
{ id: 99, label: 'Other' }
];
